export const getCurrentProgressMs = (playback) => {
  return playback.progress_ms;
};

export const getTrackDurationMs = (playback) => {
  return playback.item.duration_ms;
};

export const getProgressRatio = (currentProgressMs, trackDurationMs) => {
  return Math.min(1, currentProgressMs / trackDurationMs);
};
